import { render } from "./assignFun.vue?vue&type=template&id=4b6889ee"
import script from "./assignFun.vue?vue&type=script&lang=js"
export * from "./assignFun.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__